import { css } from '@emotion/react';

const frameStyles = css`
  width: 100%;
  height: 100vh;
  border: none;
  display: block;
`;

export default function DeliverabilityHubPage() {
  return (
    <iframe
      css={frameStyles}
      src="/Send Limit Restrictions - Claude.html"
      title="Deliverability Hub"
    />
  );
}
